import { Flex } from "@redotech/arbiter/flex";
import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const FreightWireCarrierInput = groupInput({
  customerId: input<string>({ validator: nonEmptyValidator }),
  apiKey: input<string>({ validator: nonEmptyValidator }),
});

export type FreightWireCarrierValue = InputSchema.Value<
  typeof FreightWireCarrierInput
>;

export type FreightWireCarrierForm = InputSchema.Input<
  typeof FreightWireCarrierInput
>;

export const FreightWireCarrierDefault = (): FreightWireCarrierValue => ({
  customerId: "",
  apiKey: "",
});

export const CreateFreightWireCarrierForm = memo(
  function CreateFreightWireCarrierForm({
    carrierInput,
  }: {
    carrierInput: FreightWireCarrierForm;
  }) {
    return (
      <Flex dir="column">
        <RedoTextInput
          label="Customer ID"
          placeholder=""
          setValue={carrierInput.inputs.customerId.setValue}
          value={carrierInput.inputs.customerId.value}
        />
        <RedoTextInput
          label="API key"
          placeholder=""
          setValue={carrierInput.inputs.apiKey.setValue}
          value={carrierInput.inputs.apiKey.value}
        />
      </Flex>
    );
  },
);
